import React from 'react';
import { JsonRpcProvider } from '@ethersproject/providers';

const MainProviderContext = React.createContext(undefined as JsonRpcProvider | undefined);
export default MainProviderContext;
